// extracted by mini-css-extract-plugin
export default {"card":"OKejbrs","wrapper":"mcOwPLi","image":"G0fmM2B","title":"q9SSFyg","description":"P1BaXFS","dark":"I_zxdr1","light":"m6J1KVA","noTitle":"Z_hLGkg AQi6YMD"};